import React, { FC } from 'react';
import { Grid } from '@material-ui/core';
import { NavigationCard, NavigationCardProps } from './card';

export interface NavigationCardListProps {
 cards: NavigationCardProps[];
}

export const NavigationCardList: FC<NavigationCardListProps> = ({ cards }) => {
 return (
  <Grid container spacing={2} justifyContent="flex-start">
   {cards.map((card, idx) => (
    <Grid key={idx} item>
     <NavigationCard {...card} />
    </Grid>
   ))}
  </Grid>
 );
};
